export const BANNER_SNOOZE_DAYS = 1
export const BANNER_REFRESH_EVENT = 'unify:banner-refresh'
export const INTRO_OPEN_CLASS = 'unify-intro-open'
export const OPEN_TOUR_EVENT = 'unify:open-tour'

const key = (userId) => `unify:banner-after:${userId}`

export const bannerAllowedAt = (userId) => {
  try {
    const value = Number(localStorage.getItem(key(userId)))
    return Number.isFinite(value) && value > 0 ? value : 0
  } catch (err) {
    return 0
  }
}

const holdBannerFor = (userId, ms) => {
  try {
    localStorage.setItem(key(userId), String(Date.now() + ms))
  } catch (err) {
    // storage unavailable; the banner returns on the next load
  }
  window.dispatchEvent(new Event(BANNER_REFRESH_EVENT))
}

export const snoozeBanner = (userId) => holdBannerFor(userId, BANNER_SNOOZE_DAYS * 24 * 60 * 60 * 1000)
